import React, { PureComponent } from 'react';
import { Container, Row } from 'reactstrap';
import CardBasic from './components/CardBasic';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import uuid from 'uuid'

const hostname = window && window.location && window.location.hostname ? window.location.hostname : '';
let plans = [];

//load correct plans based on the url
if (hostname === 'app.postured.io') {
  plans = require('../../utils/mockData').prodPlans
} else {
  plans = require('../../utils/mockData').devPlans
}

class PricingCards extends PureComponent {

  state = { price: null };

  componentWillMount () {
    return this.props.user ? null : this.props.history.push('/unauthorized');
  }

  getCards () {
    return plans.map((plan) => {
      return <CardBasic
        showButton={true}
        key={uuid()}
        name={plan.name}
        price={plan.price}
        features={plan.features}
        src={plan.src}
        outline={plan.outline}
        stripePlanId={plan.stripePlanId} />
    })

  }

  render () {
    return (
      <Container>
        {/* <Row>
          <Col md={12}>
            <h3 className='page-title'>Pricing Cards</h3>
            <h3 className='page-subhead subhead'>Use this elements, if you want to show some hints or additional
              information</h3>
          </Col>
       </Row>*/}
        <Row>
          {this.getCards()}
        </Row>
      </Container>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps)(withRouter(PricingCards));


// WEBPACK FOOTER //
// ./src/components/pricing_cards/PricingCards.js